export default {
    init() {
    },
    finalize() {
    }
};
